import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Header, Message, Icon, Popup } from 'semantic-ui-react';
import FormikImageUploadAdapted from '../../bookWorksheet/components/common/FormikImageUploadAdapted';
import FormikImageUpload from '../../components/FormikImageUpload';

/**
 * ProfileFormHeader component - Reusable header for all profile forms
 * @param {Object} props - Component props
 * @param {string} props.title - Profile form title (e.g., "Administrator Profile")
 * @param {Object} props.profile - Profile data object
 * @param {Object} props.userProfile - User profile from Redux
 * @param {boolean} props.isUploading - Upload loading state
 * @param {Object} props.uploadError - Upload error object
 * @param {string} props.successMessage - Success message string
 * @param {string} props.urlFieldName - Field name for image URL
 * @param {string} props.fileFieldName - Field name for image file
 * @param {string} props.flagFieldName - Field name for new image flag
 * @param {string} props.imageLabel - Label for the image upload
 * @param {Function} props.onChange - Callback when image changes
 * @returns {JSX.Element} ProfileFormHeader component
 */
const ProfileFormHeader = ({
  title,
  profile,
  userProfile,
  // isUploading,
  uploadError,
  successMessage,
  urlFieldName = "profileImageUrl",
  fileFieldName = "profileImageFile",
  flagFieldName = "hasNewImageFile",
  imageLabel = "Profile Image",
  onChange
}) => {
  // State to control the success popup
  // const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);

  // Effect to handle success message popup with auto-close
  // useEffect(() => {
  //   if (successMessage) {
  //     setIsSuccessPopupOpen(true);

  //     // Auto-close after 5 seconds
  //     const timer = setTimeout(() => {
  //       setIsSuccessPopupOpen(false);
  //     }, 5000);

  //     // Cleanup timer on unmount or when successMessage changes
  //     return () => clearTimeout(timer);
  //   } else {
  //     setIsSuccessPopupOpen(false);
  //   }
  // }, [successMessage]);
  return (
    <Grid.Row style={{ marginTop: "-85px", marginRight: "10px" }}>
      <Grid.Column width={4} verticalAlign='bottom'>
        <Header as="h3">{title}</Header>
      </Grid.Column>

      <Grid.Column width={4}>
        {/* Upload Status Messages */}
        {/* {isUploading && (
          <div className='imgThumb'>
            <Grid.Row className="noFiveTopNoBottomPad">
              <Grid.Column width={16}>
                <Message info>
                  <Icon name="spinner" loading />
                  <span>Uploading image...</span>
                </Message>
              </Grid.Column>
            </Grid.Row>
          </div>
        )} */}
      </Grid.Column>
      <Grid.Column width={6}>
        <Grid>
          {successMessage && (
            <Grid.Row >
              <Grid.Column width={16} >
                <Message info style={{
                  marginTop: "60px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                  <Message.Header>{successMessage}</Message.Header>
                </Message>
              </Grid.Column>
            </Grid.Row>
          )}

          {uploadError && (
            <div style={{ paddingTop: '5px' }}>
              <Grid.Row className="noFiveTopNoBottomPad">
                <Grid.Column width={16}>
                  <Message negative style={{
                    marginTop: "60px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <Message.Header>Upload Error</Message.Header>
                    <p>{uploadError.message || uploadError.userMessage || 'Error uploading image'}</p>
                  </Message>
                </Grid.Column>
              </Grid.Row>
            </div>
          )}
        </Grid>
        {/* Success Popup - Shows for 5 seconds when triggered */}

      </Grid.Column>
      <Grid.Column className="" width={2} verticalAlign='middle'>

        {userProfile?.data?.userId && (
          <div style={{ width: "110px", minHeight: "100px" }}>
            <FormikImageUploadAdapted
              key={profile?.uuid || `new-${urlFieldName}`}
              name={urlFieldName}
              component={FormikImageUpload}
              urlFieldName={urlFieldName}
              fileFieldName={fileFieldName}
              flagFieldName={flagFieldName}
              hideInputFields={true}
              label={imageLabel}
              onChange={onChange}
            />
          </div>
        )}

      </Grid.Column>
    </Grid.Row>
  );
};

// PropTypes validation
ProfileFormHeader.propTypes = {
  title: PropTypes.string.isRequired,
  profile: PropTypes.object,
  userProfile: PropTypes.object,
  isUploading: PropTypes.bool,
  uploadError: PropTypes.object,
  successMessage: PropTypes.string,
  urlFieldName: PropTypes.string,
  fileFieldName: PropTypes.string,
  flagFieldName: PropTypes.string,
  imageLabel: PropTypes.string,
  onChange: PropTypes.func
};

export default ProfileFormHeader;
